import { useCallback } from 'react';

import { ONBOARDING_CONFIG } from '../features/onboarding/constants';
import { useStores } from '../stores/useStores';

export function useSideMenu() {
  const { onboardingStore, uiStore } = useStores();

  const handleClose = useCallback(() => {
    if (ONBOARDING_CONFIG.MENU_ACTIONS.has(onboardingStore.step)) {
      return null;
    }
    uiStore.setSideMenuOpen(false);
  }, [uiStore, onboardingStore]);

  const handleToggle = () => {
    uiStore.setSideMenuOpen(!uiStore.sideMenuOpen);
  };

  return {
    handleClose,
    handleToggle,
  };
}
